export const getHourLabel = (hours: number = 0): string => {
  return `${hours} hour${hours > 1 ? "s" : ""}`;
};
